import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination';

interface UsersPaginationProps {
  page: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
}

export function UsersPagination({
  page,
  totalPages,
  onPrevious,
  onNext,
}: UsersPaginationProps) {
  const isFirstPage = page === 1;
  const isLastPage = page === totalPages;

  return (
    <Pagination className="pt-2">
      <PaginationContent className="flex items-center gap-4">
        <PaginationItem>
          <PaginationPrevious
            href="#"
            onClick={(event) => {
              event.preventDefault();
              onPrevious();
            }}
            aria-disabled={isFirstPage}
            className={isFirstPage ? 'pointer-events-none opacity-50' : ''}
          />
        </PaginationItem>
        <PaginationItem>
          <span className="text-sm text-neutral-600">
            Page <span className="font-medium text-neutral-900">{page}</span> of{' '}
            <span className="font-medium text-neutral-900">{totalPages}</span>
          </span>
        </PaginationItem>
        <PaginationItem>
          <PaginationNext
            href="#"
            onClick={(event) => {
              event.preventDefault();
              onNext();
            }}
            aria-disabled={isLastPage}
            className={isLastPage ? 'pointer-events-none opacity-50' : ''}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
